import { Box, Stack } from '@mui/material';

import { url } from '../../appRouter/url';
import { ContentLoading, EasyBreadcrumbs, type EasyBreadcrumbsItem, NoContentInfo } from '../../components/general';
import { useNormalizedParams } from '../../hooks/useNormalizedParams';
import { usePageTitle } from '../../hooks/usePageTitle';
import { trpc } from '../../trpc';
import { DurchgangPlanung } from './DurchgangPlanung';

export const DurchgangPlanungPage = () => {
  const { akaThemaId } = useNormalizedParams();

  if (akaThemaId === undefined) {
    throw new TypeError('Die Aka-Thema-Id fehlt in der URL.');
  }

  const themaQuery = trpc.thema.getThemaByAkaThemaId.useQuery(akaThemaId);

  usePageTitle(themaQuery.data && `${themaQuery.data.thema.buchungsnummer} | Veranstaltung anlegen`);

  if (themaQuery.error) {
    return <NoContentInfo content="Thema des Durchgangs konnte nicht geladen werden" />;
  }

  if (themaQuery.isLoading || !themaQuery.data) {
    return <ContentLoading />;
  }

  const breadcrumbs: EasyBreadcrumbsItem[] = [
    {
      href: url.root(),
      label: 'Dashboard',
    },
    {
      href: url.thema.details(themaQuery.data.thema.akaThemaId),
      label: 'Thema',
    },
    {
      href: '',
      label: 'Durchgang anlegen',
    },
  ];

  return (
    <Stack direction="column">
      <Box sx={{ my: 2 }}>
        <EasyBreadcrumbs items={breadcrumbs} />
      </Box>
      <DurchgangPlanung thema={themaQuery.data.thema} />
    </Stack>
  );
};
